import { api, getTenant, getUserName } from "../../hooks";


export const createExperience = (formData, callback) => {
  api.ibldmcareer.postExperience(
    { org: getTenant(), username: getUserName() },
    JSON.stringify(formData),
    (data) => {
      callback({success: true, data: data});
    },
    (error) => {
      callback({success: false, error: error});
    }
  );
}

export const updateExperience = (formData, callback) => {
  api.ibldmcareer.putExperience(
    { org: getTenant(), username: getUserName(), id: formData.id },
    JSON.stringify(formData),
    (data) => {
      callback({ success: true, data: data });
    },
    (error) => {
      callback({ success: false, error: error });
    }
  );
}

export const createEducation = (formData, callback) => {
  api.ibldmcareer.postEducation(
        { org: getTenant(), username: getUserName() },
        JSON.stringify(formData),
        (data) => {
              callback({ success: true, data: data });
     
        },
        (error) => {
  
          callback({ success: false, error: error });
        }
      );

    }


    export const updateEducation = (formData, callback) => {
      api.ibldmcareer.putEducation(
        { org: getTenant(), username: getUserName(), id: formData.id },
        JSON.stringify(formData),
        (data) => {
          callback({ success: true, data: data });
        },
        (error) => {
          callback({ success: false, error: error });
        }
      );
}


export const deleteExperience = (id, callback) => {
  api.ibldmcareer.deleteExperience(
    { org: getTenant(), username: getUserName(), id: id },
    (data) => {
      callback({ success: true, data: data });
    },
    (error) => {
      callback({ success: false, error: error });
    }
  );
};


export const deleteEducation = (id, callback) => {
  api.ibldmcareer.deleteEducation(
    { org: getTenant(), username: getUserName(), id: id },
    (data) => {
      callback({ success: true, data: data });
    },
    (error) => {
      callback({ success: false, error: error });
    }
  );
} 

